import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { anchor: String };
  static targets = ['collapsible'];

  connect() {
    this.openAnchor();

    // [JKB 2024-11-28]
    // window.location.hash isn't updated until the hashchange event is fired. Without this, if someone manually enters a hashed
    // URL in the URL page, the collapsible will not open and the page will not scroll to the collapsible.
    window.addEventListener('hashchange', this.openAnchor.bind(this));
  }

  openAnchor() {
    // Get the anchor from the URL
    const url_anchor = window.location.hash;

    // If the anchor is the same as value in anchor value
    if (url_anchor && url_anchor == '#' + this.anchorValue) {
      // Scroll to the relevant collapsible section
      this.collapsibleTarget.addEventListener('shown.bs.collapse', () => {
        this.collapsibleTarget.closest('.collapsible-question').scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      // Open the relevant collapsible section
      new bootstrap.Collapse(this.collapsibleTarget, { toggle: true });
      this.collapsibleTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  updateURL(event) {
    // Get the target
    const elementId = event.target.id;

    // If the collapsible is open
    if (event.target.classList.contains('show')) {
      // Show the anchor in the URL
      history.replaceState(null, null, `#${elementId}`);
    } else if (window.location.hash === `#${elementId}`) {
      // Otherwise remove the anchor from the URL
      history.replaceState(null, null, window.location.pathname);
    }
  }
}
